import React from "react";
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import { Box, Typography, Tab, Tabs } from '@mui/material';
import InvoiceCard from "../component/InvoiceCard";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const HistoryInovoiceTab = (props) => {
  // console.log("HistoryInovoiceTab",props)
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value}
            TabIndicatorProps={{ style: { background: '#b3853e' } }}
            variant="fullWidth"
            textColor="danger"
            indicatorColor="primary"
            onChange={handleChange}
            aria-label="basic tabs example">
            <Tab sx={{ "word-break": "break-word" }} label="โพยทั้งหมด" {...a11yProps(0)} />
            <Tab label="โพยที่ยังไม่ออกผล" {...a11yProps(1)} />
            <Tab label="โพยที่ออกผลแล้ว" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 place-items-center">
            {props?.historyData?.map((data)=>(
              <InvoiceCard data={data}/>
            ))}
           
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 place-items-center">
          {props?.historyData?.filter(data => data.isWin === "wait").map((data)=>(
              <InvoiceCard data={data}/>
            ))}
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-2 place-items-center">
          {props?.historyData?.filter(data => data.isWin === "no" || data.isWin === "yes").map((data)=>(
              <InvoiceCard data={data}/>
            ))}
          </div>
        </TabPanel>
      </Box>
    </div>
  );
};

export default HistoryInovoiceTab;
